module.exports = __webpack_public_path__ + "static/img/cont44_03.126d231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_03.jpg
// module id = ChLA
// module chunks = 0